export default __webpack_public_path__ + "static/media/8.a1e4ea14.svg";